import React from 'react';

import { cn } from '@/shared/utils/utils';

export const IRONVIEW_LOGO_SRC = '/static/images/IronView_Vector.svg';

export const applyIronviewLogoFallback = (
  target: HTMLImageElement,
  tone: 'adaptive' | 'dark' | 'light' = 'adaptive'
) => {
  target.onerror = null;
  target.src = IRONVIEW_LOGO_SRC;
  target.classList.remove('brightness-0', 'invert', 'dark:brightness-0', 'dark:invert');
  if (tone === 'adaptive') {
    target.classList.add('dark:brightness-0', 'dark:invert');
  } else if (tone === 'light') {
    target.classList.add('brightness-0', 'invert');
  }
};

interface IronviewLogoProps
  extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'> {
  tone?: 'adaptive' | 'dark' | 'light';
}

const IronviewLogo = React.forwardRef<HTMLImageElement, IronviewLogoProps>(
  ({ alt = 'Ironview', className, tone = 'adaptive', ...props }, ref) => (
    <img
      ref={ref}
      src={IRONVIEW_LOGO_SRC}
      alt={alt}
      className={cn(
        'h-auto w-auto object-contain',
        tone === 'adaptive' && 'dark:brightness-0 dark:invert',
        tone === 'light' && 'brightness-0 invert',
        className
      )}
      {...props}
    />
  )
);

IronviewLogo.displayName = 'IronviewLogo';

export { IronviewLogo };
